import { useEffect, useState } from "react";

/** card: the big tile · bug: broadcast score bar · compact: slimmer bar · mini: logo and score only */
export type EmbedLayout = "card" | "bug" | "compact" | "mini";
export const LAYOUTS: EmbedLayout[] = ["card", "bug", "compact", "mini"];

/** Smallest iframe width each layout is designed for (bug is 236 px wide, compact 200, mini about 130). */
export const MIN_WIDTH: Record<EmbedLayout, number> = { card: 480, bug: 236, compact: 176, mini: 0 };

export const pickLayout = (width: number): EmbedLayout => LAYOUTS.find((l) => width >= MIN_WIDTH[l]) ?? "mini";

export const asLayout = (v: string | null | undefined): EmbedLayout | null => (LAYOUTS as string[]).includes(v ?? "") ? (v as EmbedLayout) : null;

/** The width of the iframe the page is running in (its own viewport), kept up to date as the host resizes it. */
export const useViewportWidth = () => {
  const [w, setW] = useState(() => window.innerWidth);
  useEffect(() => {
    const on = () => setW(window.innerWidth);
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);
  return w;
};
